<template>
    <div class="w-full h-full">
        <FormModal v-if="showCreateTier" @cancel="showCreateTier = false;" @confirm="addCustomerTier()"
            :valid="validCustomerTier" title="Add new customer tier" subtitle="Add your subscription tiers"
            submitButtonText="Add tier">
            <CustomInput v-model="addNewCustomerTier.name" label="Name" type="text" />
            <CustomInput v-model="addNewCustomerTier.description" label="Description" type="textarea"
                :multiline="true" />
            <CustomSelect v-model="addNewCustomerTier.paidSubscription" :options="trueOrFalse"
                label="Paid subscription" />
            <CustomInput v-if="addNewCustomerTier.paidSubscription" v-model="addNewCustomerTier.price" label="Price"
                type="Number" />

        </FormModal>

        <Header title="End users" icon="UsersRound" />

        <SubHeader title="User analysis">
            <template v-if="topLineData.activeUsers != undefined && serverItemsLength != undefined" v-slot:stats>
                <StatBox name="Total users (All time)" currency="" :number="topLineData.totalUsers" icon="Users" />
                <StatBox name="Active users (60 days)" :number="topLineData.activeUsers" currency="" icon="Speech" />
                <StatBox name="Percentage of active users" :number="topLineData.percentage.toFixed(2)"
                    :percentage="true" icon="Percent" />
                <StatBox name="Total number of tiers" :number="serverItemsLength" currency="" icon="Users" />

            </template>
        </SubHeader>

        <WhiteBox title="Customer tiers" :subText="`View your customer segments`">
            <template v-slot:buttons>
                <CustomButton id="createContract" small text="Create new tier" type="action" icon="Plus"
                    @click="showCreateTier = true" />
            </template>
            <template v-slot:content>
                <EasyDataTable :headers="headersTable1" :items="customerTiers" :loading="loading"
                    v-model:server-options="serverOptions" :server-items-length="serverItemsLength" :hide-footer="false"
                    :no-hover="true">
                    <template #loading>
                        <div class="p-4 w-full flex justify-center">
                            <svg class="animate-spin text-gray-400 w-12 h-12" xmlns="http://www.w3.org/2000/svg"
                                fill="none" viewBox="0 0 24 24">
                                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                    stroke-width="4"></circle>
                                <path class="opacity-75" fill="currentColor"
                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                                </path>
                            </svg>
                        </div>
                    </template>
                    <template #empty-message>
                        <div class="flex justify-center py-4">
                            <div
                                class="flex justify-center items-center text-gray-500 rounded-full bg-gray-50 px-5 py-2 ">
                                <p class="text-sm mr-2">No results</p>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                    stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 0 1-1.125-1.125M3.375 19.5h7.5c.621 0 1.125-.504 1.125-1.125m-9.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-7.5A1.125 1.125 0 0 1 12 18.375m9.75-12.75c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125m19.5 0v1.5c0 .621-.504 1.125-1.125 1.125M2.25 5.625v1.5c0 .621.504 1.125 1.125 1.125m0 0h17.25m-17.25 0h7.5c.621 0 1.125.504 1.125 1.125M3.375 8.25c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m17.25-3.75h-7.5c-.621 0-1.125.504-1.125 1.125m8.625-1.125c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M12 10.875v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125M13.125 12h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125M20.625 12c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5M12 14.625v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 14.625c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m0 1.5v-1.5m0 0c0-.621.504-1.125 1.125-1.125m0 0h7.5" />
                                </svg>
                            </div>
                        </div>
                    </template>
                    <template #header-action="header">
                        <div class="w-full text-right">
                            {{ header.text }}
                        </div>
                    </template>
                    <template #item-action="audience">
                        <div class="flex justify-end items-center py-1 gap-1">
                            <CustomButton small text="" @click="deleteCustomerTier(audience.id)" icon="Trash2"
                                type="warning" />
                        </div>
                    </template>
                </EasyDataTable>
            </template>
        </WhiteBox>
    </div>
</template>

<script setup>
</script>

<script>
import Header from "@/components/Header.vue";
import WhiteBox from "@/components/WhiteBox.vue";
import CustomButton from "@/components/inputs/CustomButton.vue";
import { DateTime } from 'luxon';
import StatBox from "@/components/StatBox.vue";
import SubHeader from "@/components/SubHeader.vue";
import FormModal from "@/components/modals/FormModal.vue";
import CustomInput from "@/components/inputs/CustomInput.vue";
import CustomSelect from "@/components/inputs/CustomSelect.vue";


export default {
    name: "manage-publsihers",
    components: {
        Header,
        WhiteBox,
        CustomButton,
        StatBox,
        SubHeader,
        FormModal,
        CustomInput,
        CustomSelect
    },
    props: {
    },

    data() {
        return {
            showCreateTier: false,
            serverOptions: {
                page: 1,
                rowsPerPage: 50,
            },

            trueOrFalse: [
                { id: true, text: "Yes" },
                { id: false, text: "No" },

            ],

            serverItemsLength: undefined,

            topLineData: {
                totalUsers: undefined,
                activeUsers: undefined,
                percentage: undefined,
                audiences: 1
            },

            addNewCustomerTier: {
                name: "",
                description: "",
                paidSubscription: undefined,
                price: null
            },

            headersTable1: [
                { text: "Name", value: "name" },
                { text: "Id", value: "id" },
                { text: "Description", value: "description" },
                { text: "Paid", value: "paidSubscription" },
                { text: "Price", value: "price" },
                { text: "Action", value: "action" },

            ],
            customerTiers: [

            ],
        }
    },
    created() {

        this.getCustomerTiers(0, 50)
        this.getSummaryData()

    },
    methods: {

        niceDateTime(dateObject) {
            return DateTime.fromISO(dateObject).toLocaleString(DateTime.DATE_SHORT)
        },

        async addCustomerTier() {
            try {
                const token = localStorage.getItem('token')
                const api = localStorage.getItem('apiType')

                this.loading = true

                const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/customer-tier`, {
                    method: "POST",
                    body: JSON.stringify(this.addNewCustomerTier),
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {

                    this.loading = true
                    this.showCreateTier = false
                    this.addNewCustomerTier = {
                        name: "",
                        description: "",
                        paidSubscription: undefined,
                        price: null
                    }
                    this.getCustomerTiers(0, 50)
                }


            } catch (error) {
                console.log(error)
                return;
            }
        },

        async deleteCustomerTier(id) {
            try {
                const token = localStorage.getItem('token')
                const api = localStorage.getItem('apiType')

                this.loading = true

                const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/customer-tier/${id}`, {
                    method: "DELETE",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {

                    this.loading = true
                    this.getCustomerTiers(0, 50)
                }


            } catch (error) {
                console.log(error)
                return;
            }

        },

        async getCustomerTiers(page, size) {
            try {
                const token = localStorage.getItem('token')
                const api = localStorage.getItem('apiType')

                this.loading = true

                const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/customer-tier?page=${page}&size=${size}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                    var object = await response.json()
                    this.serverItemsLength = object.totalElements
                    this.customerTiers = object.content
                    this.loading = false
                }

            } catch (error) {
                return;
            }

        },

        async getSummaryData() {
            try {
                const token = localStorage.getItem('token')
                const api = localStorage.getItem('apiType')

                this.loading = true

                const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/audience/top-bar`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                    var object = await response.json()
                    this.topLineData.totalUsers = object.totalUsers
                    this.topLineData.activeUsers = object.activeUsers
                    this.topLineData.percentage = (object.activeUsers / object.totalUsers) * 100

                }

            } catch (error) {
                return;
            }

        },

    },
    computed: {
        validCustomerTier() {
            if (this.addNewCustomerTier.paidSubscription != null) {
                if (this.addNewCustomerTier.paidSubscription) {
                    return this.addNewCustomerTier.name != "" && this.addNewCustomerTier.description != "" && this.addNewCustomerTier.paidSubscription != undefined && this.addNewCustomerTier.price != null

                } else {
                    return this.addNewCustomerTier.name != "" && this.addNewCustomerTier.description != "" && this.addNewCustomerTier.paidSubscription != undefined

                }
            } else {
                return false
            }
        }
    },
    watch: {
        serverOptions: {
            deep: true,
            handler(val) {
                this.getAudiences(val.page - 1, val.rowsPerPage)
            }
        },
    }
}
</script>